//panel.tsx — the settings panels' section and row layout

import type { ReactNode } from 'react'

export function Section({ title, children }: { title: string; children: ReactNode }) {
	return (
		<section className="popover-section">
			<h3 className="popover-section-title">{title}</h3>
			{children}
		</section>
	)
}

export function Row({
	label,
	hint,
	children,
}: {
	label: string
	hint?: string
	children: ReactNode
}) {
	return (
		<label className="row">
			<span className="row-label">
				{label}
				{hint && <span className="row-hint">{hint}</span>}
			</span>
			{children}
		</label>
	)
}
